import { downloadDriverInvoice } from "@api/Rest/download/driverInvoice.pdf";
import DownloadIcon from "@mui/icons-material/Download";
import { IconButton, Tooltip, Typography } from "@mui/material";
import type { ColumnDef } from "@tanstack/react-table";
import type { DeliveryPayment } from "@types_def/models/deliveryPayment.types";

import { DataTableColumnHeader } from "@/components/ui/data-table-column-header";

import { DateCell } from "./CustomCells/DateCell";
import { DriverNameCell } from "./CustomCells/NameCell";
import { PriceCell } from "./CustomCells/PriceCell";
import { StatusCell } from "./CustomCells/StatusCell";

export const DELIVERY_PAYMENT_COLUMNS: ColumnDef<DeliveryPayment>[] = [
  {
    id: "id",
    accessorKey: "id",
    enableSorting: true,
    meta: { label: "Numéro de facture" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Numéro de facture" />,
    cell: ({ row }) => <Typography variant="body2">{row.original.id}</Typography>,
  },
  {
    id: "driver",
    accessorFn: (row) => row.driver?.fullName ?? "",
    enableSorting: false,
    meta: { label: "Driver" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Driver" />,
    cell: ({ row }) => <DriverNameCell>{row.original}</DriverNameCell>,
  },
  {
    id: "createdAt",
    accessorKey: "createdAt",
    enableSorting: true,
    meta: { label: "Date" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Date" />,
    cell: ({ row }) => <DateCell>{row.original.createdAt}</DateCell>,
  },
  {
    id: "status",
    accessorKey: "status",
    enableSorting: false,
    meta: { label: "Statut" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Statut" />,
    cell: ({ row }) => <StatusCell>{row.original.status}</StatusCell>,
  },
  {
    id: "amount",
    accessorKey: "amount",
    enableSorting: true,
    meta: { label: "Montant" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Montant" />,
    cell: ({ row }) => <PriceCell>{row.original.amount}</PriceCell>,
  },
  {
    id: "action",
    accessorKey: "deliveryId",
    enableSorting: false,
    meta: { label: "Action", align: "center" },
    header: () => <Typography variant="subtitle1">Action</Typography>,
    cell: ({ row }) => (
      <Tooltip title="Download invoice">
        <IconButton
          aria-label="Download invoice"
          color="primary"
          onClick={() => {
            downloadDriverInvoice(String(row.original.deliveryId));
          }}
          size="small"
          sx={{ border: 1, borderColor: "divider", boxShadow: 1, "&:hover": { boxShadow: 2 } }}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    ),
  },
];
